import React from 'react';
import { CheckIcon } from 'lucide-react';
export function TransformationSection() {
  const benefits = [{
    title: 'PASO 1:',
    description: 'Técnica, materiales y protocolo de implementación'
  }, {
    title: 'PASO 2:',
    description: 'Cómo diferenciarte y posicionarte en el mercado'
  }, {
    title: 'PASO 3:',
    description: 'Cómo captar clientas Premium'
  }, {
    title: 'PASO 4:',
    description: 'Cómo fidelizar clientas para que vuelvan todos los meses'
  }];
  return <section className="py-8 md:py-12 px-4 bg-[#2F0240] pl-[16px] pr-[16px] space-y-[0px] pt-[0px] pb-[0px] mt-[10px] mb-[10px]" data-id="element-393">
      <div className="max-w-5xl mx-auto mt-[-15px] mb-[-15px] pt-[0px] pb-[0px]" data-id="element-394">
        <div className="rounded-2xl p-8 md:p-12 mb-8 bg-[#FFFFFF] animate-neon-violet pt-[30px] pb-[30px]" data-id="element-395">
          <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-396">
            EN UN FIN DE SEMANA ¿QUÉ VAS A APRENDER?👇
          </p>

          <div className="space-y-4" data-id="element-397">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4 rounded-lg p-4 shadow-sm bg-[#FAC7F3B1]" data-id="element-398">
                <CheckIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-399" />
                <span className="text-lg text-gray-700" data-id="element-400">
                  <span className="font-black uppercase text-[#353135]" data-id="element-401">
                    {benefit.title}
                  </span>{' '}
                  {benefit.description}
                </span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-[#FC9DFF] font-[700] text-[20px] md:text-2xl mb-8" data-id="element-402">
          Aunque todavía no tengas clientas ni experiencia.
        </p>
      </div>
    </section>;
}